import React from 'react'
import Link from 'next/link'
import { PromoBannerButton } from '@mc/certificates-design-system'
import { useTranslation } from '@mc/i18n'
import { TrackClick } from 'pages/certificates/tracking'
import { useSignup } from '../SignUpButton'

export type SignupBannerCtaProps = {
  kind?: React.ComponentProps<typeof PromoBannerButton>['kind']
  arrowTheme?: React.ComponentProps<typeof PromoBannerButton>['arrowTheme']
  href?: string
  text?: string
  action?: string
}

export const SignupBannerCta = ({
  kind,
  arrowTheme,
  href,
  text,
  action,
}: SignupBannerCtaProps = {}) => {
  const { t } = useTranslation('@mc/certificates')
  const { handleClick, fullHref, product } = useSignup({ href })
  const signUpText = t('marketingPages.common.signUp')

  return (
    <TrackClick
      event='purchaseClick'
      action={action ?? signUpText}
      product={product}
    >
      <PromoBannerButton
        render={<Link href={fullHref} />}
        onClick={handleClick}
        kind={kind}
        arrowTheme={arrowTheme}
        hideTextOnMobile
      >
        {text ?? signUpText}
      </PromoBannerButton>
    </TrackClick>
  )
}
